import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Bell, CheckCircle2 } from "lucide-react";
import api, { fmtDate } from "@/lib/api";

export default function Notifications() {
  const nav = useNavigate();
  const [items, setItems] = useState([]);

  const load = () => api.get("/customer/notifications").then((r) => setItems(r.data));
  useEffect(() => {
    load();
    api.post("/customer/notifications/mark-read").catch(() => {});
  }, []);

  return (
    <div data-testid="notifications-page">
      <div className="bg-tenant-gradient text-white px-5 pt-6 pb-6 flex items-center gap-3">
        <button data-testid="header-back" onClick={() => nav(-1)} className="w-9 h-9 rounded-full bg-white/15 grid place-items-center">
          <ArrowLeft className="w-4 h-4" />
        </button>
        <div className="font-extrabold tracking-tight text-lg">Notifications</div>
      </div>

      <div className="px-5 pt-6 space-y-2.5">
        {items.map((n) => (
          <div key={n.id} data-testid={`notif-${n.id}`} className="bg-white border border-slate-100 rounded-2xl p-3.5 card-shadow flex gap-3">
            <div className="w-10 h-10 rounded-xl bg-blue-50 text-tenant-primary grid place-items-center">
              <Bell className="w-4 h-4" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-bold text-sm">{n.title}</div>
              <div className="text-[12px] text-slate-500 leading-snug">{n.body}</div>
              <div className="text-[10px] text-slate-400 mt-1">{fmtDate(n.created_at)}</div>
            </div>
            {n.read && <CheckCircle2 className="w-3.5 h-3.5 text-emerald-500 shrink-0" />}
          </div>
        ))}
        {items.length === 0 && <div className="text-center text-slate-400 text-sm py-12">No notifications.</div>}
      </div>
      <div className="h-10" />
    </div>
  );
}
